export default "__VITE_ASSET__D3LN2Nzf__"